import { Fragment, useMemo } from "react";
import type { NumericMotionPolicyInput } from "../../lib/numbers/numeric-motion-policy";
import { tokenizeNumericText } from "../../lib/numbers/numeric-text-tokenizer";
import { FintheonNumber } from "./FintheonNumber";

export interface FintheonNumericTextProps extends NumericMotionPolicyInput {
  text: string | number;
  className?: string;
  title?: string;
  ariaLabel?: string;
  as?: "span" | "time" | "output";
}

export function FintheonNumericText({
  text,
  className,
  title,
  ariaLabel,
  as: Tag = "span",
  ...policy
}: FintheonNumericTextProps) {
  const normalized = String(text);
  const tokens = useMemo(() => tokenizeNumericText(normalized), [normalized]);

  return (
    <Tag
      className={className}
      title={title}
      aria-label={ariaLabel ?? normalized}
    >
      <span aria-hidden="true">
        {tokens.map((token, index) =>
          token.type === "text" ? (
            <Fragment key={`${index}:text`}>{token.value}</Fragment>
          ) : (
            <FintheonNumber
              key={`${index}:number`}
              value={token.value}
              format={token.format}
              {...policy}
            />
          ),
        )}
      </span>
    </Tag>
  );
}
